const appearanceStyles = {};
appearanceStyles.light = {};
appearanceStyles.dark = {};
const getAllModeStyles = (mode) => {
  const curMode = appearanceStyles[mode];
  const appearanceString = Object.keys(curMode).map(
    (key) => `${key}: ${curMode[key]};`
  ).join(`
`);
  return appearanceString;
};
const sendUpdate = (name, values) => {
  appearanceStyles.light[name] = values.light;
  appearanceStyles.dark[name] = values.dark;
};
export {
  getAllModeStyles,
  sendUpdate
};
